module.exports = __webpack_public_path__ + "static/media/divider.d30f122f.svg";